import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const FADE_IN = { opacity: 0, y: 24 };
const FADE_IN_VISIBLE = { opacity: 1, y: 0 };
const EASE = [0.25, 0.1, 0.25, 1];

export const Reveal = ({ children, delay = 0, className = '', margin = '-60px' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin });
  return (
    <motion.div
      ref={ref}
      initial={FADE_IN}
      animate={isInView ? FADE_IN_VISIBLE : FADE_IN}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
